import CategoryBanner from './CategoryBanner';
export default CategoryBanner;